import { render, staticRenderFns } from "./SoftwareComponentDetail.vue?vue&type=template&id=0f601816&"
import script from "./SoftwareComponentDetail.vue?vue&type=script&lang=js&"
export * from "./SoftwareComponentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports